import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Footprints, ClipboardCheck } from 'lucide-react';
export function ProductSection() {
  const mechanisms = [{
    icon: Clock,
    title: 'Timing simple',
    desc: "No 'dieta': orden mínimo para que tu digestión tenga paz."
  }, {
    icon: Footprints,
    title: 'Caminata postcomida (10 min)',
    desc: 'No gym. No presión. Una señal directa para cambiar cómo te sientes en la tarde.'
  }, {
    icon: ClipboardCheck,
    title: 'Checklist de detonantes',
    desc: 'No demoniza comida. Te ayuda a descubrir lo que A TI te infla.'
  }];
  return <section className="py-24 px-4 bg-white" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <div className="text-center mb-16" data-id="element-71">
          <span className="text-terracotta font-semibold tracking-wider text-sm uppercase" data-id="element-72">
            Presentamos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-brown mt-2 mb-6" data-id="element-73">
            Reset de Hinchazón 7 Días
          </h2>
          <p className="text-xl text-brown-light max-w-2xl mx-auto" data-id="element-74">
            Un PDF corto, práctico y office-friendly para reducir hinchazón en
            la mañana y en la tarde con un método de 3 palancas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-75">
          {mechanisms.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream-50 p-8 rounded-2xl text-center hover:shadow-md transition-shadow duration-300" data-id="element-76">
              <div className="w-14 h-14 bg-terracotta/10 text-terracotta rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-77">
                <item.icon size={28} data-id="element-78" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-79">
                {item.title}
              </h3>
              <p className="text-brown-light" data-id="element-80">{item.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-sage/5 rounded-3xl p-8 md:p-12 text-center" data-id="element-81">
          <h3 className="text-2xl font-bold text-brown mb-4" data-id="element-82">
            Eso es lo que te devuelve control:
          </h3>
          <p className="text-3xl md:text-4xl font-serif italic text-sage-dark" data-id="element-83">
            No adivinar. Saber.
          </p>
        </div>
      </div>
    </section>;
}